/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IObrienb2bNavigationMenu contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum navigationMenuSource {
    retailServerOnly = 'retailServerOnly',
    cmsOnly = 'cmsOnly',
    all = 'all'
}

export interface IObrienb2bNavigationMenuConfig extends Msdyn365.IModuleConfig {
    navigationMenuSource?: navigationMenuSource;
    cmsNavItems?: ICmsNavItemsData[];
    className?: string;
}

export interface IObrienb2bNavigationMenuResources {
    menuAriaLabel: string;
    backButtonAriaLabel: string;
    allCategoryMenuText: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
}

export interface IObrienb2bNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: IObrienb2bNavigationMenuResources;
    config: IObrienb2bNavigationMenuConfig;
}
